import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { themesMixin } from '../../../../utils/themes';
export default {
  name: 'CoreDtwinRuleExecutionHistoryExport',
  mixins: [themesMixin],
  props: {
    ruleId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    var start = new Date(new Date() - 86400000 * 2);
    var end = new Date();
    return {
      start: start,
      end: end,
      exportQuery: {
        ruleId: this.ruleId,
        time: {
          from: start,
          to: end
        }
      },
      formValid: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    backgroundColor: function backgroundColor() {
      return "background-color: ".concat(this.vuetifyColorHex('info'));
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  }),
  methods: {
    datePicked: function datePicked(dateObject) {
      this.start = new Date(dateObject.from * 1000);
      this.end = new Date(dateObject.to * 1000);
      this.exportQuery = _objectSpread(_objectSpread({}, this.exportQuery), {}, {
        time: {
          from: this.start,
          to: this.end
        }
      });
    }
  }
};